import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { BlockService, PageModule, UtilsModule } from '@gallaghercp/core-frontend';

import { BlockCalendarComponent } from '@core-app/client/blocks/block-calendar/block-calendar.component';
import { BlockEventTilesComponent } from '@core-app/client/blocks/block-event-tiles/block-event-tiles.component';
import { BlockVideoComponent } from '@core-app/client/blocks/block-video/block-video.component';
import { BlockContactsComponent } from '@core-app/client/blocks/block-contacts/block-contacts.component';

import { CoroAccordionComponent } from '@core-app/coro/blocks/coro-accordion/coro-accordion.component';
import { CoroImageBannerComponent } from '@core-app/coro/blocks/coro-image-color-bg/coro-image-color.component';
import { CoroCardWrapperComponent } from '@core-app/coro/blocks/coro-card-wrapper/coro-card-wrapper.component';
import { CoroCtaCardOpt1Component } from '@core-app/coro/blocks/coro-cta-card-opt1/coro-cta-card-opt1.component';
import { CoroCtaCardOpt2Component } from '@core-app/coro/blocks/coro-cta-card-opt2/coro-cta-card-opt2.component';
import { CoroHeroCarouselComponent } from '@core-app/coro/blocks/coro-hero-carousel/coro-hero-carousel.component';
import { CoroHeroImageCarouselComponent } from '@core-app/coro/blocks/coro-hero-image-carousel/coro-hero-image-carousel.component';
import { CoroMegaCardComponent } from '@core-app/coro/blocks/coro-mega-card/coro-mega-card.component';
import { CoroPageTemplateComponent } from '@core-app/coro/blocks/coro-page-template/coro-page-template.component';
import { CoroButtonComponent } from '@core-app/coro/components/coro-button/coro-button.component';
import { IconComponent } from '@core-app/coro/components/icon/icon.component';

import { RouterLink, RouterModule } from '@angular/router';
import { CalendarCommonModule, CalendarModule } from '@gallaghercp/core-calendar';
import { SwiperModule } from '@gallaghercp/core-swiper';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { LinkClassDirective } from '@core-app/coro/directives/link-class.directive';
import { LogPipe } from '@core-app/pipes/logPipe.pipe';
import { CoroNavFeatureCardGridComponent } from '@core-app/coro/blocks/coro-nav-feature-card-grid/coro-nav-feature-card-grid.component';
import { CoroSearchResultsPageComponent } from '@core-app/coro/blocks/coro-search-results-page/coro-search-results-page.component';

@NgModule({
  declarations: [
    BlockCalendarComponent,
    BlockContactsComponent,
    BlockEventTilesComponent,
    BlockVideoComponent,
    CoroAccordionComponent,
    CoroButtonComponent,
    CoroCardWrapperComponent,
    CoroCtaCardOpt1Component,
    CoroCtaCardOpt2Component,
    CoroHeroCarouselComponent,
    CoroHeroImageCarouselComponent,
    CoroImageBannerComponent,
    CoroMegaCardComponent,
    CoroNavFeatureCardGridComponent,
    CoroPageTemplateComponent,
    CoroSearchResultsPageComponent,
    IconComponent,
    LinkClassDirective,
  ],
  imports: [
    CommonModule,
    MatExpansionModule,
    CalendarCommonModule,
    PageModule,
    UtilsModule,
    CalendarModule,
    PopoverDirective,
    SwiperModule,
    RouterLink,
    RouterModule,
    LogPipe,
  ],
  exports: [CoroButtonComponent, IconComponent, LinkClassDirective],
})
export class CoroModule {
  private blocks = inject(BlockService);

  constructor() {
    this.blocks.addBlock('CORO-ACCORDION', CoroAccordionComponent);
    this.blocks.addBlock('CORO-CARD-WRAPPER', CoroCardWrapperComponent);
    this.blocks.addBlock('CORO-SEARCH', CoroSearchResultsPageComponent);
    this.blocks.addBlock('CONTACTS', BlockContactsComponent);
    this.blocks.addBlock('CTA-CARD-OPT1', CoroCtaCardOpt1Component);
    this.blocks.addBlock('CTA-CARD-OPT2', CoroCtaCardOpt2Component);
    this.blocks.addBlock('EVENT-TILES', BlockEventTilesComponent);
    this.blocks.addBlock('GOOGLE-CALENDAR', BlockCalendarComponent);
    this.blocks.addBlock('HERO-CAROUSEL', CoroHeroCarouselComponent);
    this.blocks.addBlock('HERO-IMAGE-CAROUSEL', CoroHeroImageCarouselComponent);
    this.blocks.addBlock('IMAGE-BANNER-COLOR-BG', CoroImageBannerComponent);
    this.blocks.addBlock('MEGA-CARD', CoroMegaCardComponent);
    this.blocks.addBlock('NAV-FEATURE-CARD-GRID', CoroNavFeatureCardGridComponent);
    this.blocks.addBlock('PAGETEMP', CoroPageTemplateComponent);
    this.blocks.addBlock('VIDEO', BlockVideoComponent);
  }
}
